import { Action } from 'redux';
import { Designation } from 'src/types/model';

export interface ItemCategoryState {
  loading: boolean;
  data: Designation[];
  error: string | null;
}

export const FETCH_DESIGNATION_REQUEST = 'FETCH_DESIGNATION_REQUEST';
export const FETCH_DESIGNATION_SUCCESS = 'FETCH_DESIGNATION_SUCCESS';
export const FETCH_DESIGNATION_FAILURE = 'FETCH_DESIGNATION_FAILURE';

export interface FetchDesignationRequestAction
  extends Action<typeof FETCH_DESIGNATION_REQUEST> {}

export interface FetchDesignationSuccessAction
  extends Action<typeof FETCH_DESIGNATION_SUCCESS> {
  payload: Designation[];
}

export interface FetchDesignationFailureAction
  extends Action<typeof FETCH_DESIGNATION_FAILURE> {
  payload: string;
}

export type DesignationActionType =
  | FetchDesignationRequestAction
  | FetchDesignationSuccessAction
  | FetchDesignationFailureAction;
